import { Chip } from '@mui/material';
import React from 'react';
import { multiChipStyles } from './NewChip';

export const CompletedChipGrid = ({ label }: { label: string }) => {
  const { classes } = multiChipStyles();
  return (
    <React.Fragment>
      <Chip
        label={label}
        variant="outlined"
        className={classes.chip}
        style={{
          color: '#5FB661',
          backgroundColor: '#E9F9EA',
          border: '2px solid #5FB661',
        }}
      />
    </React.Fragment>
  );
};
